import { graphql } from '../../types/swarmx/gql'

export const OffersQuery = graphql(`
  query Offers(
    $filter: Offer_filter
    $limit: Int
    $skip: Int
    $orderBy: Offer_orderBy
    $orderDirection: OrderDirection
  ) {
    offers(
      where: $filter
      first: $limit
      skip: $skip
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      id
      amountIn
      amountOut
      availableAmount
      maker
      offerStatus
      offerType
      specialAddresses
      isAuth
      isPrivate
      terms
      timelockPeriod
      cancelledAt
      commsLink
      createdAt
      authorizationAddresses
      expiryTimestamp
      offerPrice {
        id
        percentage
        percentageType
        pricingType
        unitPrice
        depositAssetPrice {
          priceFeedAddress
        }
        withdrawalAssetPrice {
          priceFeedAddress
        }
      }
      depositAsset {
        id
        name
        symbol
        address
        decimals
        tokenId
        assetType
        kya
        tokenStandard
        tradedVolume
      }
      withdrawalAsset {
        id
        name
        symbol
        address
        decimals
        tokenId
        assetType
        kya
        tokenStandard
        tradedVolume
      }
    }
  }
`)

/*


 1. we want to take offer and exclude some of previous one
 2. we dont want to take offer and look for next suitable 

 to take: 100
 input: 15 10 *90 10 75 10

 function findBestOffers(offers, takeAmount) {
  const takenOffers = []
  const takenPartials = []
  const currentTakeAmount = 0
  const currentPartialsSum = 0

  for (const offer of offers) {
    takenOffers.push(offer)
    if (offer.partial) {
      takenPartials.push(offer)
      currentPartialsSum += offer.amount
    }
    currentTakeAmount += offer.amount

    if (currentTakeAmount === takeAmount) return
    if (currentTakeAmount > takeAmount) {
      const difference = currentTakeAmount - takeAmount
      if (currentPartialsSum >= )
      const lastTakenPartial = takenPartials[last]
      lastTakenPartial.toTake = currentTakeAmount - lastTakenPartial.toTake
      currentTakeAmount = 
    }
  }

  return offers
 }







 */
